import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { Area } from "../models/area";
import { FilterAreas } from "../models/filters/filter-areas";

@Injectable({
providedIn: 'root'
})
export class AreaService {

    constructor(private http: HttpClient) { }

    private apiUrl = `${environment.apiUrl}`;
    private url: string = this.apiUrl + 'api/areas'; 

    /*CRUD CATALOG AREAS*/
    /*getAllAreas(): Observable<any>{
        return this.http.get<any[]>(`${this.url}/getAllAreas`);
    }*/
   
    findAllPageableAreas(filterAreas: FilterAreas, page: number, pageSize: number): Observable<any> {
        return this.http.post<any[]>(`${this.url}/page/${page}/${pageSize}`, filterAreas);
    }

    getAreaById(id: number): Observable<Area>{
        return this.http.get<Area>(`${this.url}/getAreaById/${id}`)
    }

    saveArea(area: Area): Observable<Area>{
        return this.http.post<Area>(`${this.url}/saveArea`, area)
    }

    updateArea(area: Area): Observable<Area>{
        return this.http.put<Area>(`${this.url}/updateArea/${area.id}`, area)
    }
    /*CRUD CATALOG AREAS END*/

}